import { Outlet } from 'react-router-dom';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

const Layout = () => (
  <AppLayout>
    <Outlet />
  </AppLayout>
);

export default Layout;
